const MenuDisplays = () => import(/* webpackChunkName: "serverShift" */ '@/components/dashboard/menuDisplays')
export default {
    name: 'menuDisplays',
    path: 'menu-displays',
    redirect: '/menu-displays/index',
    meta: {label: 'menu-displays'},
    component: {
        render (c) { return c('router-view') }
    },
    children: [
        {
            path: 'index',
            meta: {label: 'MenuDisplays', auth: true},
            component: MenuDisplays,
            props: true
        }
    ]
}
